import logger from '@tcp/core/src/utils/loggerInstance';
import { updateFilterFacet, getAPIConfig } from '@tcp/core/src/utils/';
import { getBotCategortIds } from '@tcp/core/src/reduxStore/selectors/session.selectors';

import endpoints from '../../endpoints';
import { executeUnbxdAPICall } from '../../handler';
import { getFormattedError } from '../../../utils/errorMessage.util';
import { getHrefLangUri } from '../../../components/features/browse/CategoryListingPage/container/CategoryListingPage.utils';

// Remove the fields which are not needed
const fieldsVal =
  'TCPPromotions,tcp_promo_price,tcp_promotion_id,related_product_swatch_images,productimage,alt_img,style_partno,giftcard,swatchimage,TCPProductIndUSStore,TCPFitMessageUSSstore,TCPFit,TCPWebOnlyFlagUSStore,TCPWebOnlyFlagCanadaStore,TCPSwatchesUSStore,top_rated,TCPSwatchesCanadaStore,product_name,TCPColor,imagename,productid,uniqueId,favoritedcount,TCPBazaarVoiceReviewCount,categoryPath3_fq,categoryPath3,categoryPath3_catMap,categoryPath2_catMap,product_short_description,min_list_price,min_offer_price,TCPBazaarVoiceRating,seo_token,prodpartno,banner,facets,auxdescription,list_of_attributes,numberOfProducts,redirect,searchMetaData,didYouMean,TCPLoyaltyPromotionTextUSStore,TCPLoyaltyPLCCPromotionTextUSStore,TcpBossCategoryDisabled,TcpBossProductDisabled,long_product_title,TCPOutOfStockFlagUSStore,TCPOutOfStockFlagCanadaStore,product_type,products,low_offer_price, high_offer_price, low_list_price, high_list_price,TCPStyleTypeUS,TCPStyleTypeCA,TCPStyleQTYCA,TCPStyleQTYUS,TCPProductIndCanadaStore,TCPCustomSalePrice,TCPCustomListPrice,isVMPEnabled,is_hard_mark_enable,influencer_tags,influencer_pick,variantTotal,store_specials,isHeroProduct';

const extraParams = {
  'facet.multilevel': 'categoryPath',
  'f.categoryPath.nameId': true,
  'f.categoryPath.max.depth': 4,
};

export const getSeoTokenJSONList = async (flag) => {
  try {
    let endpoint;
    if (flag === 'usToken') {
      endpoint = endpoints.getUSSeoTokenURL();
    } else if (flag === 'caToken') {
      endpoint = endpoints.getCASeoTokenURL();
    } else if (flag === 'noToken') {
      endpoint = endpoints.getNoHrefLangSeoTokenURL();
    }
    const apiURL = `${getHrefLangUri()}${endpoint?.URI}`;
    const response = await fetch(apiURL);
    if (await !response.ok) {
      logger.error('Error fetching getSeoTokenJSONList');
      return [];
    }
    return await response.json();
  } catch (e) {
    logger.error('Error in new plp CategoryListingPageJS - getSeoTokenJSONList catch ', e);
    return [];
  }
};

const fetchProducts = ({
  rows,
  start,
  xappURLConfig,
  categoryPathId,
  isFacetsCall,
  skipFacets,
  facetsPayload,
  apiConfig,
}) => {
  const catId = categoryPathId.includes('>') ? categoryPathId.split('>').pop() : categoryPathId;
  const botCategoryIds = getBotCategortIds();
  const { isBotRequest } = getAPIConfig();

  // Determine the promotion rule based on the bot category IDs and the bot request status
  const promotionRule = botCategoryIds?.includes(catId) && isBotRequest ? { promotion: false } : {};

  const payload = {
    body: {
      start,
      rows,
      variants: true,
      'variants.count': 0,
      version: 'V2',
      stats: 'min_offer_price',
      'facet.multiselect': true,
      selectedfacet: true,
      pagetype: 'boolean',
      fields: fieldsVal,
      ...promotionRule,
      'p-id': `categoryPathId:"${categoryPathId}"`,
      ...(isFacetsCall ? extraParams : {}),
      ...(skipFacets ? { facet: false } : {}),
      ...(updateFilterFacet(facetsPayload) || {}),
    },
    webService: endpoints.getProductviewbyCategory,
  };
  return executeUnbxdAPICall(payload, null, xappURLConfig, apiConfig)
    .then((res) => {
      return res?.body;
    })
    .catch((err) => {
      logger.error({
        error: `Error while executing Unbxd API call for new Plp catch - ${err}`,
        extraData: {
          componentName: 'CategoryListingPage',
          methodName: 'fetchProducts',
          payload: payload.body,
          categoryPathId,
          isFacetsCall,
        },
      });
      throw Object.assign(getFormattedError(err), { isServiceError: true });
    });
};

export default fetchProducts;
